import React, { useEffect, useState } from 'react';
import '../styles/Concejo.css';

/*Imagenes*/
import Jose_img from '../imagenes/concejoMunicipal/alcalde.png';
import Froilan_img from '../imagenes/concejoMunicipal/Froilan_03.png';
import Zunita_img from '../imagenes/concejoMunicipal/Zunita_03.png';
import Tito_img from '../imagenes/concejoMunicipal/Tito_03.png';
import Eberardo_img from '../imagenes/concejoMunicipal/Eberardo_03.png';
import Nancy_img from '../imagenes/concejoMunicipal/Nancy_03.png';
import Fredy_img from '../imagenes/concejoMunicipal/Fredy_03.png';
import David_img from '../imagenes/concejoMunicipal/David_03.png';
import Wilbert_img from '../imagenes/concejoMunicipal/Wilbert_03.png';
import Aydee_img from '../imagenes/concejoMunicipal/Aydee_03.png';

const alcalde={
  nombre: 'Jose Alberto Flores Cruz',
  cargo: 'Alcalde Provincial',
  imagen: Jose_img,
};

const regidores=[
  {
    nombre: 'Froilán Batallanos Ibarra',
    cargo: 'Regidor Provincial',
    imagen: Froilan_img,
  },
  {
    nombre: 'Zunita Zeballos Ugarte',
    cargo: 'Regidor Provincial',
    imagen: Zunita_img,
  },
  {
    nombre: 'Tito Ronald Baca Yallerco',
    cargo: 'Regidor Provincial',
    imagen: Tito_img,
  },
  {
    nombre: 'Aydee Laime Mendoza',
    cargo: 'Regidor Provincial',
    imagen: Aydee_img,
  },
  {
    nombre: 'Eberardo Ataucuri Alvis',
    cargo: 'Regidor Provincial',
    imagen: Eberardo_img,
  },
  {
    nombre: 'Nancy Salhua Janampa',
    cargo: 'Regidor Provincial',
    imagen: Nancy_img,
  },
  {
    nombre: 'Fredy Williams Molina Mendoza',
    cargo: 'Regidor Provincial',
    imagen: Fredy_img,
  },
  {
    nombre: 'David Vilca Elme',
    cargo: 'Regidor Provincial',
    imagen: David_img,
  },
  {
    nombre: 'Wilbert Sapacayo Sapacayo',
    cargo: 'Regidor Provincial',
    imagen: Wilbert_img,
  },
];


function ConcejoMunicipal(){
 
  return(
    <section className="directorio">
      <h2 className="titulo">Concejo Municipal</h2>

      {/* Alcalde */}
      <div className="alcalde">
        <img src={alcalde.imagen} alt={alcalde.nombre} />
        <h3>{alcalde.nombre}</h3>
        <p>{alcalde.cargo}</p>
      </div>

      {/* Regidores */}

      <div className="regidores">
        {regidores.map((persona, index) => (
          <div className="tarjeta" key={index}>    
            <img src={persona.imagen} alt={persona.nombre} />
            <div className='regidor-contenido'>
              <h3>{persona.nombre}</h3>
              <p>{persona.cargo}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );  
};
export default ConcejoMunicipal;
